/* eslint-disable camelcase */
import { BaseCrudService } from "./baseCrudService";
import apiRoutes from "./apiRoutes";

import {
  CourseLanguageData,
  CourseSubtitleData,
  CourseTopicData,
  CourseTagsData,
} from "../models/courseData";

/**
 * Service for handling API requests related to course languages.
 *
 * @extends BaseCrudService
 * @returns {Promise<CourseLanguageData[]>} - Array of course language objects.
 */
export class CourseLanguageService extends BaseCrudService {
  async getCourseLanguages() {
    const response = await this.getAll<CourseLanguageData[]>(apiRoutes.course_languages);
    return response.data;
  }
}

/**
 * Service for handling API requests related to course subtitles.
 *
 * @extends BaseCrudService
 * @returns {Promise<CourseSubtitleData[]>} - Array of course subtitle objects.
 */
export class CourseSubtitleService extends BaseCrudService {
  async getCourseSubtitles() {
    const response = await this.getAll<CourseSubtitleData[]>(apiRoutes.course_subtitles);
    return response.data;
  }
}

/**
 * Service for handling API requests related to course topics.
 *
 * @extends BaseCrudService
 * @returns {Promise<TopicsData[]>} - Array of course topic objects.
 */
export class CourseTopicsService extends BaseCrudService {
  async getCourseTopics() {
    const response = await this.getAll<CourseTopicData[]>(apiRoutes.topics);
    return response.data;
  }
}

/**
 * Service for handling API requests related to course tags.
 *
 * @extends BaseCrudService
 * @returns {Promise<CourseTagsData[]>} - Array of course tags objects.
 */
export class CourseTagsService extends BaseCrudService {
  async getCourseTags() {
    const response = await this.getAll<CourseTagsData[]>(apiRoutes.tags);
    return response.data;
  }
}
